
import { RevList } from '@ds/components/List'
import { RevListItem } from '@ds/components/ListItem'
import { RevRadio } from '@ds/components/Radio'

import ProgressBar from '@core/components/ProgressBar'
import { trackClick } from '@tracking/events'

import { TRACKING_ZONE } from '../Page/constants'

import { PLACEHOLDER_RANGES, RATE_RANGES } from './RateFilter.constants'
import translations from './RateFilter.translations'

export default {
  components: {
    ProgressBar,
    RevList,
    RevListItem,
    RevRadio,
  },
  props: {
    ranges: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    const { rate_min: min, rate_max: max } = this.$route.query
    const range = RATE_RANGES.find(({ value }) => value === `${min}-${max}`)

    return {
      selectedRangeValue: range?.value || RATE_RANGES[0].value,
    }
  },
  computed: {
    translations: () => translations,
    rateRanges() {
      return [{ rateRange: 'between_1_and_5', percentage: 100 }]
        .concat(this.ranges)
        .map(({ rateRange, percentage }, index) => ({
          disabled: percentage === 0,
          label: RATE_RANGES[index].label,
          percentage,
          rateRange,
          value: RATE_RANGES[index].value,
        }))
    },
    rangesList() {
      return this.ranges.length > 0 ? this.rateRanges : PLACEHOLDER_RANGES
    },
  },
  methods: {
    handleRangeClick({ value, rateRange, disabled }) {
      if (!disabled && this.selectedRangeValue !== value) {
        trackClick({
          pageType: this.$route.name,
          zone: TRACKING_ZONE,
          name: `review_star_filter_${rateRange}`,
        })

        this.selectedRangeValue = value

        const [min, max] = value.split('-')

        this.$navigation.push({
          type: 'internal',
          query: { ...this.$route.query, rate_min: min, rate_max: max },
        })
      }
    },
  },
}
